import httpClient from '../../../global/httpClient';
import * as apis from '../../../constants/api';

export const getLiveCourse = (courseId) => httpClient.get(`${apis.GET_LIVE_COURSE}/${courseId}`);

export const getLiveToken = (channelId) => httpClient.get(`${apis.GET_LIVE_TOKEN}/${channelId}`);